import React from 'react'

import { DataTableSorting, SortingControl } from './DataTableSorting'

export function TableSortingController<Columns>(
  column: Columns,
  sortingControl: SortingControl<Columns>,
  options: { activeColor?: boolean } = {
    activeColor: true,
  }
): React.ReactNode {
  return (
    <DataTableSorting<Columns>
      activeColor={options?.activeColor}
      column={column}
      control={sortingControl}
    />
  )
}
